import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { UserDataService } from '../../../shared/services/user-data/user-data.service';
import { NotificationComponent } from '../../../vass-core/components/notification/notification.component';
import { NotificationModel } from '../../../vass-core/components/notification/notificationModel.interface';
import { CommonService } from '../../../vass-core/services/common.service';
import { LayoutService } from '../../services/layout/layout.service';
import { WallService } from '../../services/wall/wall.service';

import { SimulatorService } from '../../../pre-simulator/services/simulator/simulator.service';
import { RecoverUser } from '../../../shared/models/recoverUser.model';
import { GtmService } from '../../../shared/services/gtm/gtm.service';
import { MIN_STATUS } from '../../../shared/utils/constants';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent implements OnInit, OnDestroy {
  @ViewChild(NotificationComponent, { static: true }) notification: NotificationComponent;

  public status: number;
  public unread: number = 0;
  public collapseWall = false;
  private listStatus = MIN_STATUS;

  public isRejected = false;
  public listRejectReasons = [];
  private subscription = new Subscription();

  constructor(
    private _commonService: CommonService,
    private _layoutService: LayoutService,
    private _userDataService: UserDataService,
    private authService: AuthService,
    private _wallService: WallService,
    private simulatorService: SimulatorService,
    private gtm: GtmService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.getUserData();
    this.getStatus();
    this.receiveNotification();
    this.subscription.add(
      this._wallService.getUnread().subscribe((data) => {
        this.unread = data;
      }),
    );
    this.subscription.add(
      this.router.events.pipe(distinctUntilChanged()).subscribe((event: any) => {
        if (event.url !== '/dashboard') {
          this.collapseWall = true;
        } else {
          this.collapseWall = false;
        }
      }),
    );

    this.subscription.add(this.simulatorService.getConfigInputs().subscribe());

    this.getIsRejected();
    this.getRejectReason();
  }

  private getStatus() {
    this.authService
      .getStatus()
      .pipe(distinctUntilChanged())
      .subscribe((response) => {
        this.status = parseFloat(response);
      });
  }

  private getUserData() {
    this.subscription.add(
      this._layoutService.recoverUserData().subscribe((userData: RecoverUser) => {
        this._userDataService.mapperUserData(userData);
        this.subscription.add(
          this.gtm
            .getUserIdGTM(this._userDataService.getUserData().level2Data.holders[0].email)
            .subscribe(
              (userId) => {
                sessionStorage.setItem('idGTM', userId.idClient);
              },
              (err) => {},
            ),
        );
      }),
    );
  }

  private receiveNotification() {
    let method: string;

    this.subscription.add(
      this._commonService.notificationEv$.subscribe((notification: NotificationModel) => {
        if (notification.detail !== '') {
          method = notification.severity || 'error';
          this.notification[method](notification);
        }
      }),
    );
  }

  private getIsRejected() {
    this.subscription.add(
      this.authService.getRejectedMortgage().subscribe((data) => {
        this.isRejected = data;
      }),
    );
  }

  private getRejectReason() {
    this.subscription.add(
      this.authService.getRejectMortgageReasons().subscribe((data) => {
        this.listRejectReasons = data;
      }),
    );
  }

  ngOnDestroy(): void {
    // Hacer un next para evitar que salga cuando el usuario se vuelve a logar.
    this._commonService.sendNotification({
      key: '',
      detail: '',
      severity: 'success',
    });
    this.subscription.unsubscribe();
  }
}
